import { render, staticRenderFns } from "./recruitdetails.vue?vue&type=template&id=db41b1ce&scoped=true&"
import script from "./recruitdetails.vue?vue&type=script&lang=js&"
export * from "./recruitdetails.vue?vue&type=script&lang=js&"
import style0 from "./recruitdetails.vue?vue&type=style&index=0&id=db41b1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db41b1ce",
  null
  
)

export default component.exports